const hasIdentity = (value) => value !== undefined && value !== null && value !== ''

export const dedupeByStableId = (items = [], getStableId, getFallbackValue) => {
  const seen = new Set()

  return (Array.isArray(items) ? items : []).filter((item) => {
    const stableId = getStableId(item)
    const fallbackValue = getFallbackValue?.(item)
    const identity = hasIdentity(stableId)
      ? `id:${stableId}`
      : hasIdentity(fallbackValue)
      ? `fallback:${fallbackValue}`
      : undefined

    if (identity === undefined) return true
    if (seen.has(identity)) return false

    seen.add(identity)
    return true
  })
}
